import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AbRouterMenuComponent } from './ab-router-menu.component';

@NgModule({
  imports: [
      CommonModule,
      RouterModule
  ],
  declarations: [AbRouterMenuComponent],
  exports: [AbRouterMenuComponent]
})
export class AbRouterMenuModule { }
